/**
 * Module-level reference to the MessagePort established by the TWA via
 * CustomTabsSession.requestPostMessageChannel. Re-set on every SPA navigation
 * since Chrome invalidates the web→Android direction of the channel after each
 * History API navigation.
 */
let currentMessagePort: MessagePort | null = null;
let twaSupportsTwoWayCommunication = false;

export const setTwaMessagePort = (newPort: MessagePort) => {
  // Close the previous port before replacing it so stale onmessage handlers
  // don't linger and accumulate across navigations.
  currentMessagePort?.close();
  currentMessagePort = newPort;
  // Notify listeners that the TWA message channel is now open so they can
  // send messages immediately without waiting for a navigation event.
  window.dispatchEvent(new CustomEvent("twa-channel-ready"));
};

// Used to determine if twa and pwa can talk together, won't be
// true until new TWA version is rolled out to everyone
export const setTwaMessageCommunicationSupported = () => {
  twaSupportsTwoWayCommunication = true;
};

export const isTwaTwoWayCommunicationSupported = () =>
  twaSupportsTwoWayCommunication;

export const isTwaPortReady = () => currentMessagePort !== null;

export const sendTwaMessage = (data: string) => {
  if (!currentMessagePort) {
    return false;
  }
  console.debug("[TWA ←]", data);
  currentMessagePort.postMessage(data);
  return true;
};
